function flash(selector) {
	$(selector)
        .css('opacity', 0)
            .animate({ backgroundColor: 'khaki', opacity: 1.0 }, 800)
            .animate({ backgroundColor: '#ffffff' }, 350, function() { this.style.removeAttribute('filter'); });
}
window.aqd = {
  addLogViewDetailLink: function ( data, linkText) {

    return "<a href='javascript:void(0);' onclick='$.logDetailDialog(this, " + data.id + ",\"" + linkText + "\")'>" + linkText + "</a>";
  },
  Model: function() {
      this.__initialized = false;
     
      if (this.initialize)
        this.initialize.apply(this, arguments);

      this.__initialized = true;
    
    
  }, 
  component: function(obj) {
    var newObj = function () { };
    if (typeof obj.constructor === "function")
      newObj = obj.constructor;
    delete obj.constructor;
    $.extend(newObj.prototype, obj);
    return newObj;
  },
   

  addViewModels: function(obj) {
    $.extend(window.aqd.viewmodels);
    $.each(window.aqd.viewmodels,
      function(key, val) {
        val.factory = window.aqd.viewmodels.factory(val);
      });
  },
  viewmodels: {
  
  },
  dirtyTracker: function(form, warningMessage) {
    var obj = {
      markDirty: function() {
        obj.isDirty = true;
        $.SetNavigationWarning(warningMessage);
        form.find('.ui-dirty-button').removeAttr('disabled', 'disabled');
        
      },

      markClean: function() {
        obj.isDirty = false;
        form.find('.ui-dirty-button').attr('disabled', 'disabled').css('cursor', 'default');
        
        $.ClearNavigationWarning();
      }
    };
    form.find('input,textarea').change(function () { obj.markDirty(); });

    form.on('update').change(function () { obj.markDirty(); });
    return obj;
  }
};
window.aqd.ElementBaseModel = function(containerElement) {

      
      this.containerElement = $(containerElement);
      this.containerElement.attr('data-aqdmodel', true);
      this.containerElement[0].aqdModel = this;
      aqd.Model.call(this);

this.el = function() {
  return this.containerElement;
};
  this.find = function(selector) {
    return $(this.containerElement).find(selector);
  };

  this.on = function() {
    this.containerElement.on.apply(this, arguments);
  };
  this.trigger = function() {
    this.containerElement.trigger.apply(this, arguments);
  };
};


window.aqd.JQGridModelMixin = function (grid) {
    var self = this;
    if (self.onGridRowSelected) {
        $(grid)
            .on('jqGridSelectRow',
                function(e, id) {
                    self.onGridRowSelected.apply(self, arguments);
                });
    }
    if (self.onGridLoaded) { 
        $(grid).on('jqGridLoadComplete', function() {
             self.onGridLoaded.apply(self, arguments);
        });
    }
    this.pagerElementId = '#' + $(grid).attr('id') + "_pager",
    this.onSelectRow = function () {

    };
    this.onUpdate = function () {

    };
    this.addButton = function (buttonData) {
        $(grid).navButtonAdd(this.pagerElementId, buttonData);
    };
    this.reload = function () {
        $(grid).trigger('reloadGrid');
    }

};
window.aqd.DialogModel = function (containerElement) {

    this.dialog = $(containerElement).getContainingDialog();

    window.aqd.ElementBaseModel.call(this, containerElement);

  var self = this;
  this.dialog.dialogDiv.bind("dialogopen", function (event, ui) {
      if (self.onLoad) {
          
        self.onLoad();
    }
  });
    
    this.center = function() {
        this.dialog.dialogDiv.dialog('widget').position({ my: "center", at: "center", of: window });
    }
  this.closeDialog = function() {
    this.dialog.closeDialog();
  };
};

var dateSettings = {
	STAdjustment: 5,
	DTAdjustment: 6,
	StoreAs: 'UTC',
	disabled: false
};
var reIsoDate = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z|(\+|\-)((\d{2})(:(\d{2}))))?$/;
Date.parseISO = function (val) {
	var m;
	m = typeof val === 'string' && val.match(reIsoDate);
	
	if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000) || 0);
	return null;
};
var reIsoDate = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z|(\+|\-)((\d{2})(:(\d{2}))))?$/;

Date.parseISO = function (val) {
  var m;
  m = typeof val === 'string' && val.match(reIsoDate);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000) || 0);
  return null;
};
function createCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toGMTString();
	}
	else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}
// Translation mapping from .NET time to other date formats used in portal - not currently used, but here for reference
var dateFormatData = {
    'ddd ': { 'jQuery': 'D', 'VB': 'ddd', 'flatpickr': 'D' },
    'dddd ': { 'jQuery': 'DD', 'VB': 'dddd', 'flatpickr': 'l' },
    'd': { 'jQuery': 'd', 'VB': 'd', 'flatpickr': 'j' },
    'dd ': { 'jQuery': 'dd', 'VB': 'dd', 'flatpickr': 'd' },
    'M': { 'jQuery': 'm', 'VB': 'm', 'flatpickr': 'n' },
    'MM ': { 'jQuery': 'mm', 'VB': 'mm', 'flatpickr': 'm' },
    'MMM ': { 'jQuery': 'M', 'VB': 'mmm', 'flatpickr': 'M' },
    'MMMM ': { 'jQuery': 'MM', 'VB': 'mmmm', 'flatpickr': 'F' },
    'yy': { 'jQuery': 'y', 'VB': 'yy', 'flatpickr': 'y' },
    'yyyy ': { 'jQuery': 'yy', 'VB': 'yyyy', 'flatpickr': 'Y' },
    'h': { 'jQuery': 'h', 'VB': 'H', 'flatpickr': 'g' },
    'hh ': { 'jQuery': 'hh', 'VB': 'hh', 'flatpickr': 'h' },
    'H': { 'jQuery': 'H', 'VB': 'H', 'flatpickr': 'G' },
    'HH ': { 'jQuery': 'HH', 'VB': 'hh', 'flatpickr': 'H' },
    'm ': { 'jQuery': 'I', 'VB': 'N', 'flatpickr': 'i' },
    'mm ': { 'jQuery': 'II', 'VB': 'nn', 'flatpickr': 'i' },
    'tt ': { 'jQuery': 'tt', 'VB': 'am/pm', 'flatpickr': 'a' },
    't ': { 'jQuery': 't', 'VB': 'a/p', 'flatpickr': 'a' }
};

$.toDictionary = function(jsonObj) {
    var arr = [];
    for (var i in jsonObj) {
        arr.push({ Key: i, Value: jsonObj[i] });
    }
    return arr;

};
$.htmlEncode = function(text) {
  return $('<div />').text(text).html();
}
$.fn.getAQDModel = function () {
    var modelEl = $(this).find('[data-aqdmodel]:first');
    if (modelEl.length == 0)
        return null;
    return modelEl[0].aqdModel;
}
$.fn.getContainingAQDModel = function () {
    var modelEl = $(this).parents('[data-aqdmodel]:first');
    if (modelEl.length == 0)
        return null;
    return modelEl[0].aqdModel;
}
$.fn.flatpickr = function (config) {
    var el = $(this)[0];
    el._flatpickr = el._flatpickr || new flatpickr(el, config);
    return el._flatpickr;
};
$.fn.getFlatpickr = function() {
    return $(this)[0]._flatpickr || null;
};


$.fn.getDateValue = function () {
    if ($(this).is('.flatpickr-input'))
        if ($(this).getFlatpickr().selectedDates.length == 0)
            return null;
        return $(this).getFlatpickr().selectedDates[0] || new Date();
    return $(this).datepicker('getDate');

};


$.fn.setDateValue = function (value) {
    if ($(this).is('.flatpickr-input')) {
        if (value == '')
            return $(this).getFlatpickr().clear();
        return $(this).getFlatpickr().setDate(value);
    }
    $(this).datepicker('setDate', value);

};
$.fn.formatDate = function (format, dateValue) {
    if (dateValue == null || dateValue == false || dateValue == '')
        return "";
    return $.fn.formatDateValue.apply(this, [dateValue, format]);
};
$.fn.formatDateValue = function (dateValue, format) {
    format = format || $(this).attr('format');
    
    return $.datepicker.formatDate(convertDateFormat(format), dateValue);

};

// See https://bugs.jqueryui.com/ticket/8989
$(function($) {
  $.widget("ui.dialog",
    $.ui.dialog,
    {
      _allowInteraction: function (event) {
        return $(event.target).closest(".flatpickr-calendar").length > 0 || this._super(event);
      }
    });
});


$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a,
        function() {
            var name = this.name;
            var splitName = this.name.split('.');
            var value = this.value;
            var targetObj = o;
            var parentObj = o;
            $.each(splitName, function () {
                name = this;
                if (targetObj[name] === undefined) {

                    targetObj[name] = {};

                }
                parentObj = targetObj;
                targetObj = targetObj[name];
            });
            if (jQuery.isEmptyObject(parentObj[name]))
                parentObj[name] = undefined;
            if (parentObj[name] !== undefined) {
                if (!parentObj[name].push) {
                    parentObj[name] = [parentObj[name]];
                }
                parentObj[name].push(value || '');
            } else {
                parentObj[name] = value || '';
            }
        });
    return o;
};
$.paramToForm = function(a,nameprefix, container) {
	if (!a)
		return "";
	var keys = Object.keys(a);
	var container = container || $('<div/>');
	var nameprefix = nameprefix || '';
	var isArray = $.isArray(a);
	for (var i in keys) {
		var key = keys[i];
		var name = nameprefix == '' ? key : "[" + key + "]";
		if (typeof a[key] === "number" || typeof a[key] === "string")
			$('<input />').attr('type', 'hidden').attr('name', nameprefix + name).val(a[key]).appendTo(container);
		else {
		//	$('<input />').attr('type', 'hidden').attr('name', nameprefix + name + ".index").val(key).appendTo(container);
			var name = nameprefix == '' ? key : "[" + key + "]";
			$.paramToForm(a[key], nameprefix + name, container);
		}
	}
	return container;
}
// Copied from jQuery - didn't quite give us what we expected when serializing a large object
$.paramToString = function(a, traditional) {
	var s = [];

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if (traditional === undefined) {
		traditional = jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if (jQuery.isArray(a) || a.jquery) {
		// Serialize the form elements
		jQuery.each(a, function() {
			add(this.name, this.value);
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for (var prefix in a) {
			buildParams(prefix, a[prefix]);
		}
	}

	// Return the resulting serialization
	return s.join("&").replace(' ', "+");

	function buildParams(prefix, obj) {
		if (jQuery.isArray(obj)) {
			// Serialize array item.
			jQuery.each(obj, function(i, v) {
				if (traditional || /\[\]$/ .test(prefix)) {
					// Treat each array item as a scalar.
					add(prefix, v);
				} else {
					// If array item is non-scalar (array or object), encode its
					// numeric index to resolve deserialization ambiguity issues.
					// Note that rack (as of 1.0.0) can't currently deserialize
					// nested arrays properly, and attempting to do so may cause
					// a server error. Possible fixes are to modify rack's
					// deserialization algorithm or to provide an option or flag
					// to force array serialization to be shallow.
					buildParams(prefix + "[" + (typeof v === "object" || jQuery.isArray(v) ? i : "") + "]", v);
				}
			});

		} else if (!traditional && obj != null && typeof obj === "object") {
			// Serialize object item.
			jQuery.each(obj, function(k, v) {

				buildParams(prefix + "." + k, v);
			});

		} else {
			// Serialize scalar item.
			add(prefix, obj);
		}
	}

	function add(key, value) {
		// If value is a function, invoke it and return its value
	    try {
	        value = jQuery.isFunction(value) ? value() : value;
	        s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
	    } catch (err) {
	    }
	    
	}
};

$.showLoadingSpinner = function() {
	if ($.showLoadingSpinner.loadingDiv == undefined)
	    $.showLoadingSpinner.loadingDiv = $("<div id='loadingIcon' class='loadingSpinnerContainer'><a class='loadingSpinner'></a></div>").appendTo($(document.body));

    $.showLoadingSpinner.loadingDiv.dialog({
			resizable: false,
			autoOpen: false,
			closeOnEscape: false,
			modal: true,
			draggable: false,
			dialogClass: 'noDialogTitle',
			width: 70,
			height: 70
		});
	$.showLoadingSpinner.loadingDiv.dialog("open");
};
$.hideLoadingSpinner = function () { $("#loadingIcon").dialog("close"); };
// Strips out the querystring and converts it to a json object.
// Example:
//	$.query('myurl.aspx?name=Test+User&test=123')
// Will return:
//	{
//		name: "Test User",
//		test:	123
//	}
// s = a URL
// stripPrefix = optional bool parameter, specifying whether the prefix should be stripped or not (default == false)
$.query = function (s, stripPrefix) {
	function addObjToQuery(key, data, d1) {

		var obj = {};
		if (key.indexOf("[") >= 0) {
			var indRegex = /(.*?)\[(.*?)\]/gi;
			indRegex.lastIndex = 0;
			var result = indRegex.exec(key);
			// Generate array
			if (result != null) {
				var val = data;
				// convert floats
				if (/^[0-9.]+$/.test(val)) val = parseFloat(val);
				// ignore empty values
				var arraykey = result[1];
				var propkey = key.substring(key.indexOf("]") + 1);
				if (propkey.indexOf('.') == 0)
					propkey = propkey.substring(1);
				else
					propkey = "";
				if (d1[arraykey] == undefined || d1[arraykey] == null)
					d1[arraykey] = new Array();
				if (propkey.length > 0) {
					// Additional properties, is an object:
					index = parseInt(result[2]);
					var newobj = d1[arraykey][index];
					// if Already exists:
					if (newobj == undefined || newobj == null) {
						newobj = {};
						d1[arraykey].push(newobj);
					}
					addObjToQuery(propkey, val, newobj);
				} else {
					// No additional properties, just push it:
					d1[arraykey].push(val);
				}

			} else {
				var val = data;
				// convert floats
				if (/^[0-9.]+$/.test(val)) val = parseFloat(val);
				// ignore empty values
				d1[key] = val;
			}
		} else {
			var val = data;
			// convert floats
			if (/^[0-9.]+$/.test(val)) val = parseFloat(val);
			// ignore empty values
			d1[key] = val;
		}
	}

    s = s || "";
	var r = {};
	var q = s;
	while (s.indexOf('?') >= 0)
		s = s.substring(s.indexOf('?') + 1); // remove everything up to
	s = s.replace(/\&$/, ''); // remove the trailing &
	jQuery.each(s.split('&'), function () {
		var splitted = this.split('=');
		var key = unescape(unescape(splitted[0]));
		if (stripPrefix != undefined && stripPrefix === true) {
			if (key.indexOf(".") >= 0) {
				key = key.substring(key.indexOf(".") + 1);
			}
		}

		// Only support for arrays at this point (no key based)
		addObjToQuery(key, splitted[1], r);

	});
	return r;

};

$.postJSON = function(url, model, success) {
	return $.ajax({ type: 'POST', url: url, data: JSON.stringify(model), success: success,  contentType: 'application/json; charset=utf-8' });
				
};
// Overrides specified keys in the existing Url
// Example:
//	$.extendUrl('myurl.aspx?name=Test+User&test=123', { name: 'Replacement' });
// Will return:
//	'myurl.aspx?name=Replacement&test=123

$.extendUrl = function (existingUrl, newParameters) {
    if (newParameters == undefined)
		return existingUrl;

    var r = {};
    var url = existingUrl;
    var existing = {};
    if (existingUrl.indexOf('?') >= 0) {
        url = existingUrl.substring(0, existingUrl.indexOf('?')); // get the url
        existing = $.query(existingUrl);
    }
    $.extend(existing, newParameters);
    return url + "?" + $.paramToString(existing);  
};

$.extendUrlNonEscape = function (existingUrl, newParameters) {
    if (newParameters == undefined)
        return existingUrl;
    
    var r = {};
    var url = existingUrl;
    var existing = {};
    if (existingUrl.indexOf('?') >= 0) {
        url = existingUrl.substring(0, existingUrl.indexOf('?')); // get the url
        existing = $.query(existingUrl);
    }
    $.extend(existing, newParameters);

    return url + "?" + $.paramToString(existing);
};

$.setBoundValues = function (field, values, bool) {
  var data = $(field).data();
  
  for (var d in data) {
    if (d.indexOf("bind") == 0) {
      if (d == "bind" && data[d] != "") {
          if (field.is('input,textarea,select,button') && values[data[d]])
          $.setFieldValue(field, values[data[d]], true);
        else
          field.text(values[data[d]]);
      } else if (d == "bindValue" && values[data[d]]) {
        $.setFieldValue(field, values[data[d]], true);
      } else if (d == "bindText" && values[data[d]]) {
        field.text(values[data[d]]);
      } else {
        // get attr name
          if (values[data[d]])
            field.attr(d.substring(4).toLowerCase(), values[data[d]]);
      }
      
    }
  }





};
$.setFieldValue = function (field, value, bool) {

	if (field.parent().is('.mcdropdown')) {
		if (value == null)
			value = '';
       
		field.mcDropdown().setValue(value);
	} else if (field.is('.hasDatepicker') || field.is('.flatpickr-input')) {

		if (bool == undefined || (bool != undefined && bool == true)) {
		    if (typeof value == 'string' && value != "") {


		        value = Date.parseISO(value) || new Date(value);
		    }

		    if (typeof value == "string" && value.indexOf("/Date") == 0) {
		        var r = /\/Date\(([0-9]*)\)\//;

		        value = new Date(parseInt(r.exec(value)[1]));

		    }
		    if (typeof value == "object" && value != null)
		        value = Date.parseISO(value) || new Date(value);
								
		    if (value != null && typeof value == 'string'  && value.indexOf("/Date(") == 0) {
				// Value is "/Date()/", need to parse
				value = new Date(parseInt(value.substring(6, value.length - 2)));
		    }

		    field.setDateValue(value);
		}

	} else if (field.attr('lookupUrl') != undefined && field.attr('lookupUrl') != null && field.attr('lookupUrl') != "") {
		if (value == null) {
			field.val("");
			$('#' + field.attr('linked')).val("");

		} else {
			var url = field.attr('lookupUrl') + value;


			$.get(url, function (s) {

				field.val(value);
				$('#' + field.attr('linked')).val(s);
			});
		}
	} else if (field.is('[type="radio"]')) {
		field.filter('[value="' + value + '"]').attr('checked', 'true');
		if (value != null && value.toString() == 'true') {
			field.filter('[value="true"]').attr('checked', 'true');
			field.filter('[value="on"]').attr('checked', 'true');
		} else if (value == null || value.toString() == 'false') {
			field.filter('[value="false"]').attr('checked', 'true');
			field.filter('[value="off"]').attr('checked', 'true');
		}
	} else if (field.is('[type="checkbox"]')) {

		if (value != null && value.toString() == field.attr('value') || (field.attr('value') == '' && value == true) || (value == true && field.attr('value') == 'on')) {

			field.attr('checked', 'checked').change();
		} else {
      field.attr('checked', null).change();

		}
	} else {
		if (value == null)
			value = '';
		field.val(value).trigger('change');
		field.trigger('setValue', value);
		if (field.is('textarea'))
			field.text(value).trigger('change');
		if (field.length > 0 && field[0].form != null && $.data(field[0].form, 'validator'))
			field.valid();
	}
};
function setFormValues(form,model,setDates,prefix) {
  if (prefix == undefined)
    prefix = "";
  else
    prefix = prefix + ".";
  var boundprefix = prefix;
  if (boundprefix == undefined)
    boundprefix = "";
  else
    boundprefix = boundprefix + "-";
  
  for (var key in model) {
      
    var fields = $(form).find('input[name="' + prefix + key + '"],textarea[name="' + prefix + key + '"]');
    if (fields.length == 0) {
      // sometimes has trouble with "[]" characters in the prefix or key
      var s = prefix + key;
      var list = new Array();
      $(form).find('input[name$="' + key + '"],textarea[name$="' + prefix + key + '"]').each(function() {
        if ($(this).attr('name') == prefix + key)
          list.push(this);
      });
      fields = $(list);

    }
    $.setFieldValue(fields, model[key], setDates);
 


  }

  var boundFields = $(form).find('*[data-bind]');
  $.setBoundValues(boundFields, model, true);
}
(function ($) {
  $.fn.serializeEncoded = function () {
    var data = {};
    $.each($(this).serializeArray(),
      function() {
        data[this.name] = this.value.replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      });
    return $.paramToString(data);
    
  };
  $.fn.extendGridUrl = function (params) {
        $(this).setGridParam({ url: $.extendUrl($(this).getGridParam('url'), params) });
    };
	$.fn.updateForm = function(model, prefix) {
	  
		setFormValues(this, model, true, prefix);
	  $(this).trigger('formUpdated', { model: model, prefix: prefix });
	};
})($);
$.setFormValues = function (formId, model, setDates, prefix) {
	var form = $('#' + formId);
	setFormValues(form, model, setDates, prefix);
};
$.buildUrl = function(url, querystring) {
	if (url.substring(0, 1) == "/" && url.substring(0, $.currentSitePath.length) != $.currentSitePath)
		url = $.currentSitePath +  url.substring(1);

	var qs = "";
	if (querystring != undefined) {
		for (var key in querystring) {
			qs += key + "=" + encodeURIComponent(querystring[key]) + "&";
		}
	}
	if (qs.length > 0 && url.indexOf("?") > 0) {
		url = url + "&" + qs;
	} else if (qs.length > 0) {
		url = url + "?" + qs;
	}
	return url;
};

function dictionary() {
	var innerDictionary = {};
	this.getValue = function(key) {
		return innerDictionary[key];
	};
    this.setValue = function(key, value) {
		innerDictionary[key] = value;
	};
}
$.dictionary = new dictionary();
$.isDirty = false;

$.setDirty = function(isDirtyFlag) {
	$.isDirty = isDirtyFlag;
};
String.prototype.trim = function() { return this.replace(/^\s+|\s+$/g, ''); };

function addToDate(date, hours, minutes) {
	var m_secs = date.getTime();

	if (hours)
		m_secs += hours * 60 * 60 * 1000;
	if (minutes)
		m_secs += minutes * 60 * 1000;

	return new Date(m_secs);
    


}


function convertDateToOffset(date, offset) {
}
function convertDateFromUTC(date, convertTo) {
	if (convertTo == "UTC")
		return date;
	return addToDate(date, dateSettings[convertTo + "Adjustment"]);
}
function convertDateToUTC(date, convertFrom) {
	if (convertFrom == "UTC")
		return date;
	return addToDate(date, 0 - dateSettings[convertFrom + "Adjustment"]);
}
function convertDate(date, convertFrom, convertTo) {
	if (convertFrom == convertTo)
		return date;

	date = convertDateToUTC(date, convertFrom);

	date = convertDateFromUTC(date, convertTo);
	return date;
}
function convertToStore(date, displayVal) {
	date = convertDateToUTC(date, displayVal);
	date = convertDateFromUTC(date, dateSettings['StoreAs']);
	return date;
}
function convertFromStore(date, displayVal) {
	date = convertDateToUTC(date, dateSettings['StoreAs']);
	date = convertDateFromUTC(date, displayVal);
	return date;
}

$(document).ready(function() {
	// Wire up to window.unload event!

	window.onbeforeunload = function() {
		var eventData = {};
	    eventData["display"] = false;
		eventData["message"] = "";
		var event = $.getEvent(eventData, "/page/unloaded", "js");
		event.trigger();
		if (eventData["display"])
			return eventData["message"];


	};
});

$.extend($.expr[':'], {
	isFocused: function(elem) { return $(elem).data("focused") != null && $(elem).data("focused") == true; }
});
$(document).ready(function () {
	// If IE7, disable ALL jQuery animations!
	if ($('#BodyIE7').length > 0)
		$.fx.off = true;

	$.ajaxPrefilter(function (s,originalData,jqXHR) {
		// Override the default Send function,
		// This allows us to inject custom code into the send, but work with the same data (not possible using the jQuery v1.3.2 - creates new data object for each success function)
		if (originalData.disableAutomaticAjaxResponseHandling) { 
				// Clear the success handler. This should be done via promise callbacks instead
				s.success = null;
				return;
		}
		
		var combineFunctions = function (function1) {
			return function (data, p1, p2, p3, p4) {
				if (data == null)
					return null;
				var originalData = data;
				var ajaxResponseData = null;
				var converteddata = data;

				if (converteddata != null && typeof (converteddata) == "string" && converteddata[0] == "{")
					converteddata = eval("(" + converteddata + ")");
				if (converteddata != null && typeof (converteddata) == "object" && converteddata["Type"] != undefined && converteddata["Type"].indexOf("application/json; multipart") == 0) {
					// Is multipart json


					function1.call(this, converteddata["Response"][0]["Body"], p1, p2, p3, p4);
					for (var key in converteddata["Response"]) {
						if (typeof (converteddata) == "object" && converteddata["Type"] != undefined && converteddata["Type"] != "application/json") {
							$.handleAjaxResponse.call(this, converteddata["Response"][key]["Body"]);
						}
					}


				} else {
					// Not multipart json, just try processing as normal
					var converteddata = data;
					
					function1.call(this, data, p1, p2, p3, p4);
					if (typeof (converteddata) == "string" && converteddata[0] == "{")
						converteddata = eval("(" + converteddata + ")");
					
					if (typeof (converteddata) == "object")
						$.handleAjaxResponse.call(this, converteddata);
				
				}
			};
		};
		if (s.jSuccess == undefined) {
			s.jSuccess = s.success;

			s.success = combineFunctions(s.jSuccess);
			
		}
	});
	$(document).bind('showValidationWarning', function (evt, data) {
		var message = data;
		if (message != undefined && message != null) {
			$.infoDialog(message, "Warning");
			$(evt.target).data('warningMessage', null);et
		}

	});
	// Update mask with custom definitions
	//$.mask.rules = $.extend($.mask.rules, { 'N': /[NS]/, 'W': /[WE]/ });
	if ($.mask && $.mask.definitions) { 
		$.mask.definitions['E'] = '[EW]';
		$.mask.definitions['N'] = '[NS]';
	}

});

$.getAjaxResponse = function(url, data) { 
	var deferred = $.Deferred();
	$.ajax({ url: url, data: data, disableAutomaticAjaxResponseHandling: true }).then(function(response) { 
		$.handleAjaxResponse(response,data,deferred);
	});
	return deferred;
};


$.getEvent = function(source, absoluteTargetUrl, method) {


  if (!absoluteTargetUrl)
    absoluteTargetUrl = "";
  

	var eventUri = '/' + absoluteTargetUrl.toLowerCase().replace($.currentApplicationPath.toLowerCase(), '').replace(/\./gi, '_');

	var eventUriParts = eventUri.split("?");
	var eventName = eventUriParts[0].toLowerCase();

	var data = {};
	if (eventUriParts.length > 1) {
		var dataParts = eventUriParts[1].split("&");
		for (var dpInd in dataParts) {
			var values = dataParts[dpInd].split("=", 2);
			data[values[0]] = values[1];
		}
	}
	if (method == "get" && $(source).is("form")) {

		if (absoluteTargetUrl.indexOf("?") >= 0)
			absoluteTargetUrl = absoluteTargetUrl + "&" + $(source).serialize();
		else
			absoluteTargetUrl = absoluteTargetUrl + "?" + $(source).serialize();
	}
	// split querystring
	var parameters = {};
	if (absoluteTargetUrl.indexOf('?') > 0) {
		var URLpieces = decodeURI(absoluteTargetUrl).split('?')[1].split('&');
		for (var num = 0; num < URLpieces.length; num++) {

			var URLpiece = URLpieces[num].split('=');
			parameters[URLpiece[0]] = URLpiece[1];

		}
	}


	// fix - remove colon
	return { source: source, parameters: parameters, originalUrl: absoluteTargetUrl, event: eventName, eventType: method, data: data,
		trigger: function() {

			var handled = false;
			if ($.event.global[this.eventType + this.event]) {
				$.event.trigger(this.eventType + this.event, this); handled = true;
			}
			if ($.event.global["any" + this.event]) {
				$.event.trigger("any" + this.event, this);
				handled = true;
			}
			return !handled;
		}
	};
};

function nullconsole() {
	var obj = {};
	var methods = ["log", "debug", "info", "warn", "error", "assert", "dir", "dirxml", "trace", "group", "groupCollapsed", "groupEnd", "time", "timeEnd", "profile", "profileEnd", "count"];
	for (var i in methods) {
		obj[methods[i]] = function() { };
	}
	return obj;
}
if (typeof (window["console"]) == "undefined") {
	console = nullconsole();
} else {
	if (typeof (console["debug"]) == "undefined") {
		console["debug"] = function(arg1, arg2, arg3, arg4, arg5, arg6, arg7) {

			console.log("DEBUG: " + arg1, arg2, arg3, arg4, arg5, arg6, arg7);
		};
	}
	if (typeof (console["group"]) == "undefined") {
		console["group"] = function(arg1) {

			console.log("GROUP:" + arg1);
			console.log("{");
		};
		console["groupEnd"] = function() {

			console.log("}");

		};
	}
	if (typeof (console["assert"]) == "undefined") {
		console["assert"] = function() { };
		console["dir"] = function() { };
		console["dirxml"] = function() { };
		console["trace"] = function() { };
		console["time"] = function() { };
		console["timeEnd"] = function() { };
		console["profile"] = function() { };
		console["profileEnd"] = function() { };
		console["count"] = function() { };
	}
	var qs = window.location.search.substring(1);
	console["isDebugEnabled"] = true;
	console["isInfoEnabled"] = true;
	console["isWarnEnabled"] = true;
	console["isErrorEnabled"] = true;
	if (qs.indexOf("disableDebug") >= 0)
		console["isDebugEnabled"] = false;
	if (qs.indexOf("disableWarn") >= 0)
		console["isWarnEnabled"] = false;
	if (qs.indexOf("disableError") >= 0)
		console["isErrorEnabled"] = false;
	if (qs.indexOf("disableInfo") >= 0)
		console["isInfoEnabled"] = false;

	var qs = window.location.search.substring(1);
	var enabledLoggers = {};
	if (qs.indexOf("enableLogger") >= 0) {
		var index = qs.indexOf("enableLogger");
		var endindex = 0;
		if (qs.indexOf("&", index) >= 0) {
			endindex = qs.indexOf("&", index);
		} else {
			endindex = qs.length;
		}
		var enabledLogging = qs.substring(index + 13, endindex);
		enabledLoggersStr = enabledLogging.split(',');
		if (enabledLoggersStr.length == 0) {
			enabledLoggers[enabledLogging.toLowerCase()] = true;
		} else {
			for (var i in enabledLoggersStr) {
				enabledLoggers[enabledLoggersStr[i].toLowerCase()] = true;
			}
		}
	}
}
// also add getlogger
console["getLogger"] = function(name) {
	if (typeof (name) == "undefined") {
		// Gets a logger for the current script which can be enabled/disabled:
		var scr = document.getElementsByTagName('script');
		scr = scr[scr.length - 1].getAttribute("src");
		scr = scr.substring(scr.lastIndexOf('/') + 1);
		name = scr.substring(0, scr.lastIndexOf('.js'));
	}
	if (enabledLoggers == undefined || (enabledLoggers["*"] == undefined || enabledLoggers[name.toLowerCase()] == false) && enabledLoggers[name.toLowerCase()] == undefined || enabledLoggers[name.toLowerCase()] == false) {
		return nullconsole();
	}
	return console;
};

$.extend($.fn, {
	setOuterHeight: function (height) {
		return $(this).each(function () {
			$(this).height(height);
			if ($(this).outerHeight() != height && $(this).is(':visible')) {
				var diff = $(this).outerHeight() - height;
				$(this).height(height - diff);

			}
		});
	},
	// Datepicker validation helper
	fixValidation: function () {
		if ($(this).datepicker('getDate') != null) {
			this.previousValue = $(this).datepicker('getDate').toString();

		}
		$(this).datepicker("option", "onSelect", function () { $(this).valid(); });
	},
	// Ajax helper
	ajaxForm: function (onsuccess) {
		$(this).submit(function () {
			$.post($(this).attr('action'), $(this).serialize(), onsuccess);
			return false;
		});
	}

});

var GridLoadDeferred = function (gridId, cb) {
  if (!$("#" + gridId)[0].grid) {
    // NOT READY
    window.setTimeout(function () { GridLoadDeferred(gridId, cb); }, 250);
    return;
  }
  if ($("#load_" + gridId).is(':visible')) {
    $("#" + gridId).one('jqGridAfterLoadComplete', cb);
  } else {
    cb();
  }
};
var GridSetData = function(gridId, gridData) {
  if (gridData.selected) {
    $("#" + gridId).setSelection(gridData.selected);
  }
  if (gridData.page) {

    GridLoadDeferred(gridId,
      function () {
        window.setTimeout(function() {
            $("#" + gridId).trigger('reloadGrid', [{ page: gridData.page }]);
          },
          1);
        GridLoadDeferred(gridId,
          function () {
            if (gridData.selected) {
              $("#" + gridId).setSelection(gridData.selected);
            }
          });
      });

  }

};
//Navigation blocking
$.extend($, {

  restorePageState: function (stateStr) {
        var state = JSON.parse(atob(stateStr));
        window.currentState = state;
        for (var i in state.grids) {
          var gridData = state.grids[i];
          GridSetData(i, gridData);

        }
        for (var i in state.panels) {
          var panelData = state.panels[i];
          if (panelData.expanded) {
            $("#" + i).find('>h3 .ui-icon-triangle-2-s').click();
          } else {
            $("#" + i).find('>h3 .ui-icon-triangle-2-n').click();
          }
        }
      
  },
  redirectWithPageState: function(url) {
    window.location = $.buildUrl(url, { pageState: $.getPageState() });
  },
  getPageState: function () {
    var state = { grids: {}, panels: {} };
    $('#workspaceContainer .ui-jqgrid-btable').each(function () {
      if ($(this).getGridParam('page') != 1)
        state = $.addToPageState(state,'grids', $(this).attr('id'), "page", $(this).getGridParam('page'));
      if ($(this).getGridParam('selrow'))
        state = $.addToPageState(state,'grids', $(this).attr('id'), "selected", $(this).getGridParam('selrow'));
    });
    $('#workspaceContainer .ui-collapsible').each(function () {
      if ($(this).attr('data-panel-state'))
        state = $.addToPageState(state,'panels', $(this).attr('id'), 'expanded', $(this).attr('data-panel-state') === 'expanded');
    });
    return btoa(JSON.stringify(state));
  },
  addToPageState: function (state, group, id, key, val) {
    if (!state[group]) {
      state[group] = {};
    
    }
    if (!state[group][id])
      state[group][id] = {};
    state[group][id][key] = val;
    return state;
    

  },
    SkipNavigationWarning: function (callback) {
        // Remove warning
        var tempMsg = getBlockMessage();
        if (tempMsg != undefined && tempMsg.length > 0) {
            $.ClearNavigationWarning();
            // Execute callback
            callback();
            // Replace warning
            $.SetNavigationWarning(tempMsg);
        } else {
            callback();
        }
        //     window.onbeforeunload = unloadVar;
    },
    SetNavigationWarning: function (message) {
    
		$(document).trigger({ type: 'SetNavigationWarning', Warn: true, Message: message });
	},

	ClearNavigationWarning: function () {
		$(document).trigger({ type: 'SetNavigationWarning', Warn: false });
	},

	UrlArgumentFormat: function () {
		var s = arguments[0];
		for (var i = 0; i < arguments.length - 1; i++) {
			var reg = new RegExp("%7B" + i + "%7D", "gm");
			s = s.replace(reg, arguments[i + 1]);
		}
		return s;
	}
});
$(document).ready(function () {
	if ($.datepicker)
  $.datepicker.setDefaults({ onClose: function () { el = this; window.setTimeout(function () { $(el).valid(); }, 450); } });
});
function getValidID(id) {
	// removes invalid characters
	// ID/Name must start with a letter, then may contain (a to z, A to Z), digits (0 to 9), hyphens (-), underscores (_), colons (:) and periods (.)
	// We will not using the colons or periods, (causes problems with jquery)
	var regex = /[^a-zA-Z0-9]*/gi;
	return id.replace(regex, '');
}

// Custom debugger helper

window.breakOnCall = function (obj, functionName) {
    obj[functionName + 'Override'] = obj[functionName];
    obj[functionName] = function () {
        //debugger;
        obj[functionName + 'Override'].apply(this, arguments);
    };

};
window.breakOnPropertySet = function(obj, propertyName, condition) {
obj.__defineSetter__(propertyName, function( value ) {
    if (condition == undefined || condition(value))
        //debugger;
    this["__" + propertyName] = value;
});

obj.__defineGetter__(propertyName, function(  ) {
    return this["__" + propertyName];
});

  };
	
  // Error handling
  $(document).ready(function () {
  	$.parseDate = function (date) {
  		// assume date format is yyyy-mm-dd
  		var dparts = date.toString().split('-');
  		return new Date(parseInt(dparts[0]), parseInt(dparts[1]) - 1, parseInt(dparts[2]));

  	};
  	$.fn.resizeConsequenceMatrix = function () { };
  	window.onerror = function (msg, url, linenumber) {

  		//	$.errorDetailDialog($.dictionary.getValue('unknownError'), $.dictionary.getValue('error'), "<b>Javascript Error</b><br/>" + msg + "<br /><span style='font-size:8pt;'>" + url + " - " + linenumber + "</span>", $.closeEreportDialog);
  	};
  	$.closeEreportDialog = function () {
  		var d = $('#eReportDialog');
  		if (d.length > 0 && d.is(':visible')) {
  			if (d.find('#processingDiv').length > 0 && d.find('#processingDiv').is(':visible')) {
  				d.parent().find('.ui-dialog-buttonpane').find('button:first').click();
  			}
  		}
  	};
      $.formatJavascriptErrorDetail = function (errorMessage, fileName, lineNumber, stack) {
  		if (stack == undefined)
  			stack = "";
  		else
  			stack = "<br /><br /><b>Stack:</b><br />" + stack.replace(/\n/gi, '<br />');

  		return "<b>Javascript Error</b><br/>" + errorMessage + "<br /><span style='font-size:8pt;'>" + fileName + " - " + lineNumber + stack + "</span>";
  	};
  });

  $.extend($, {
      //Portal GENERIC DIALOG
      portalDialog: function(getpathname, buttonPath, helpGuid, parentHelpGuid, callBackValue, width, doEditCheck, opts) {
          var options = {
			  height: "auto"
			  
          };          
          options = $.extend({}, options, opts);          
          $.portalStandardDialog({viewPath:getpathname, buttonPath: buttonPath, helpGuid:helpGuid, parentHelpGuid:parentHelpGuid, callback:callBackValue, width:width, doEditCheck:doEditCheck, height:options.height});
      },
      portalStandardDialog: function(opts) {
          var options = {
              viewPath: "",
              buttonPath: "",
              title:"",
              helpGuid: "",
              parentHelpGuid: "",
              callback: null,
              onClose: null,
              onOpen:null,
              doEditCheck: false,
              height: "auto",
              width: 500,
              maxHeight: 450,
              submit: null,
              submitFunction: "submitPortalDialog",
              modal: true,
              position: { my: "center", at: "center", of: window },
              divId: "genericPortalDialog",
              customButtons: null,
              customButtonsPosition: 'before',
              beforeClose: function() {
                return true; }
          };
          options = $.extend({}, options, opts);
          var portalDialogDiv = $("<div id='" +options.divId + "'></div>").appendTo($(document.body));

          var titleTxt;
          var unsavedMsg;
          var selectBtn = "";
          var closeBtn="";

          //returns an array of buttons
          getButtons = function () {
              var dbuttons = {};
              if (options.customButtons != null && options.customButtonsPosition == 'before') {
                  dbuttons = options.customButtons;
              }
              
              dbuttons[closeBtn] = function() {
                (options.cancel || function () { })();
                if (options.beforeClose()) {
                  $.genericPortalCloseDialog(this, portalDialogDiv, options.doEditCheck);
                };
              }
            if (selectBtn.length > 0) {
                  dbuttons[selectBtn] = options.submit || function () { window[options.submitFunction](options.callback, this, portalDialogDiv); };
              }
              if (options.customButtons != null && options.customButtonsPosition != 'before') {
                  $.extend(dbuttons, options.customButtons);
              }
              return dbuttons;
          };
          titleTxt = options.title;
          if (options.buttonData != undefined && options.buttonData != null) {
              var data = options.buttonData;
              data = $.extend({}, {cancel:$.dictionary.getValue("cancelButton")}, data);
              if (data.submit != null) {
                  selectBtn = data.submit;
              }
              closeBtn = data.cancel;
              
              unsavedMsg = data.unsavedMsg;
          }
          //function to display the returned data
          setdata = function (data) {
              origData = data;
              portalDialogDiv.html(data);
          }; //call the controller for the data
          $.ajax({
              type: "GET",
              url: options.viewPath,
              async: false,
              success: function (vdata) {
                  setdata(vdata);
              }
          });
          
          //here is the actual processing
          //gets the button txts
          if (options.buttonPath != '')
          $.ajax({
              type: "GET",
              url: options.buttonPath,
              dataType: "json",
              async: false,
              success: function (data) {
                  if (data.submit != null) {
                      selectBtn = data.submit;
                  }
                  if (data.close != null) {
                      closeBtn = data.close;
                  } else {
                      closeBtn = data.cancel;
                  }
                  
                  titleTxt = data.title;
                  unsavedMsg = data.unsavedMsg;
              }
          });
          //open the dialog
          var dlg = portalDialogDiv.dialog({
              autoOpen: false,
              title: titleTxt,
              closeOnEscape: false,
              close: function() {
                  if (options.onClose != null) {
                      options.onClose();
                  }
              },
              open: function() {
                  if (options.onOpen != null) {
                      options.onOpen();
                  }
              },
              width: options.width,
              height: options.height,
              buttons: getButtons(),
              resizable: false,
              modal: options.modal,
              maxHeight: options.maxHeight,
              position: options.position
          });
          portalDialogDiv.dialog("open");

          portalDialogDiv.AddHelpContext(options.helpGuid, options.parentHelpGuid);

          returnRefResults = function() {
              submitPortalDialog(options.callBack, dlg, portalDialogDiv);
          };
          window.doSubmitPortalDialog = function() { window[options.submitFunction](options.callback, portalDialogDiv, portalDialogDiv) };
          return portalDialogDiv;
      },
    //GENERIC CLOSE FUNCTION
    genericPortalCloseDialog: function (obj, divToGo, doEditCheck) {
      var theObj = obj;
      var theDiv = divToGo;
      var checkForBlockMsg = true;
      if (doEditCheck != null) {
        checkForBlockMsg = doEditCheck;
      }
        doClose = function() {
            $(theObj).dialog("close").dialog("destroy");
            $(theDiv).remove();
        };

      if (checkForBlockMsg && getBlockMessage() != undefined && getBlockMessage().length > 0) {
        $.confirmDialog(getBlockMessage(), "Portal Management", function () { $.ClearNavigationWarning(); doClose(); });
      }
      else {
        doClose();
      }
    },

    loadPrintReportCombos: function (comboNameLayout, comboSourceLayout, idTargetLayout, idValidationLayout, initialValueLayout, comboNameFormat, comboSourceFormat, idTargetFormat, idValidationFormat, initialValueFormat) {
      $("#" + comboNameLayout).mcDropdown("#" + comboSourceLayout, {
        select: function (itemValue) {
          $("#" + idValidationLayout).val(itemValue);
          $("#" + idTargetLayout).val(itemValue);
          $(document).trigger({ type: "reportLayoutSelected", reportLayoutOption: itemValue, reportLayoutId: idValidationLayout });
        },
        init: function () { $("#" + comboNameLayout).mcDropdown().setValue(initialValueLayout); },
        allowParentSelect: true
      });
      $("#" + comboNameFormat).mcDropdown("#" + comboSourceFormat, {
        select: function (itemValue) {
          $("#" + idValidationFormat).val(itemValue);
          $("#" + idTargetFormat).val(itemValue);
        },
        init: function () { $("#" + comboNameFormat).mcDropdown().setValue(initialValueFormat); },
        allowParentSelect: true
      });


    },
    resetReportWithPrintReportCombos: function (comboNameLayout, comboNameFormat, initialValueLayout, initialValueFormat, formId) {
          $("#" + formId + " input").val("");
          $("#" + formId + " :checkbox").val(true);
          $("#" + formId + " :checked").removeAttr("checked");
          $("#" + formId + " #IncludeRestrictedFields").trigger("change");
          $("#" + comboNameLayout).mcDropdown().setValue(initialValueLayout);
          $("#" + comboNameFormat).mcDropdown().setValue(initialValueFormat);
      }
  });

  $.extend($, {
      //Portal GENERIC DIALOG
      occPortalDialog: function (getpathname, buttonPath, helpGuid, parentHelpGuid, callBackValue, width, doEditCheck, opts) {
          var options = {
              height: "auto"
          };
          options = $.extend({}, options, opts);
          $.occPortalStandardDialog({ viewPath: getpathname, buttonPath: buttonPath, helpGuid: helpGuid, parentHelpGuid: parentHelpGuid, callback: callBackValue, width: width, doEditCheck: doEditCheck, height: options.height });
      },
      occPortalStandardDialog: function (opts) {
          var options = {
              viewPath: "",
              buttonPath: "",
              title: "",
              helpGuid: "",
              parentHelpGuid: "",
              callback: null,
              onClose: null,
              onOpen: null,
              doEditCheck: false,
              height: "auto",
              width: 500,
              maxHeight: 370,
              submit: null,
              submitFunction: "submitOccPortalDialog",
              modal: true,
              position: ['centre', 150],
              divId: "genericPortalDialog",
              customButtons: null
          };
          options = $.extend({}, options, opts);
          var portalDialogDiv = $("<div id='" + options.divId + "'></div>").appendTo($(document.body));

          var titleTxt;
          var unsavedMsg;
          var selectBtn = "";
          var closeBtn = "";

          //returns an array of buttons
          getButtons = function () {
              var dbuttons = {};
              if (options.customButtons != null) {
                  dbuttons = options.customButtons;
              }

              dbuttons[closeBtn] = function () {
                  $.genericPortalCloseDialog(this, portalDialogDiv, options.doEditCheck);
              };
              if (selectBtn.length > 0) {
                  dbuttons[selectBtn] = options.submit || function () { window[options.submitFunction](options.callback, this, portalDialogDiv); };
              }
              return dbuttons;
          };
          titleTxt = options.title;
          if (options.buttonData != undefined && options.buttonData != null) {
              var data = options.buttonData;
              data = $.extend({}, { cancel: $.dictionary.getValue("cancelButton") }, data);
              if (data.submit != null) {
                  selectBtn = data.submit;
              }
              closeBtn = data.cancel;

              unsavedMsg = data.unsavedMsg;
          }
          //function to display the returned data
          setdata = function (data) {
              origData = data;
              portalDialogDiv.html(data);
          }; //call the controller for the data
          $.ajax({
              type: "GET",
              url: options.viewPath,
              async: false,
              success: function (vdata) {
                  setdata(vdata);
              }
          });

          //here is the actual processing
          //gets the button txts
          if (options.buttonPath != '')
              $.ajax({
                  type: "GET",
                  url: options.buttonPath,
                  dataType: "json",
                  async: false,
                  success: function (data) {
                      if (data.submit != null) {
                          selectBtn = data.submit;
                      }
                      if (data.close != null) {
                          closeBtn = data.close;
                      } else {
                          closeBtn = data.cancel;
                      }

                      titleTxt = data.title;
                      unsavedMsg = data.unsavedMsg;
                  }
              });
          //open the dialog
          portalDialogDiv.dialog({
              autoOpen: false,
              title: titleTxt,
              closeOnEscape: false,
              close: function () {
                  if (options.onClose != null) {
                      options.onClose();
                  }
              },
              open: function () {
                  if (options.onOpen != null) {
                      options.onOpen();
                  }
              },
              width: options.width,
              height: options.height,
              buttons: getButtons(),
              resizable: false,
              modal: options.modal,
              maxHeight: options.maxHeight,
              position: options.position
          });
          portalDialogDiv.dialog("open");

          portalDialogDiv.AddHelpContext(options.helpGuid, options.parentHelpGuid);

          returnRefResults = function () {
              submitPortalDialog(options.callBack, this, portalDialogDiv);
          };
      }
 

     
  });
  /*!

  * jQuery.parseJSON() extension (supports ISO & Asp.net date conversion)

  *

  * Version 1.0 (13 Jan 2011)

  *

  * Copyright (c) 2011 Robert Koritnik

  * Licensed under the terms of the MIT license

  * http://www.opensource.org/licenses/mit-license.php

  */

  (function($) {


    // JSON RegExp

    var rvalidchars = /^[\],:{}\s]*$/ ;

    var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g ;

    var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g ;

    var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g ;

    var dateISO = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[.,]\d+)?Z/i ;

    var dateNet = /\/Date\((\d+)(?:-\d+)?\)\//i ;


    // replacer RegExp

    var replaceISO = /"(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:[.,](\d+))?Z"/i ;

    var replaceNet = /"\\\/Date\((\d+)(?:-\d+)?\)\\\/"/i ;


    // determine JSON native support

    var nativeJSON = (window.JSON && window.JSON.parse) ? true : false;

    var extendedJSON = nativeJSON && window.JSON.parse('{"x":9}', function(k, v) { return "Y"; }) === "Y";


    var jsonDateConverter = function(key, value) {

      if (typeof(value) === "string") {

        if (dateISO.test(value)) {

          return new Date(value);

        }

        if (dateNet.test(value)) {

          return new Date(parseInt(dateNet.exec(value)[1], 10));

        }

      }

      return value;

    };


    $.extend({
      parseJSON: function(data, convertDates) {

        /// <summary>Takes a well-formed JSON string and returns the resulting JavaScript object.</summary>

        /// <param name="data" type="String">The JSON string to parse.</param>

        /// <param name="convertDates" optional="true" type="Boolean">Set to true when you want ISO/Asp.net dates to be auto-converted to dates.</param>


        if (typeof data !== "string" || !data) {

          return null;

        }


        // Make sure leading/trailing whitespace is removed (IE can't handle it)

        data = $.trim(data);


        // Make sure the incoming data is actual JSON

        // Logic borrowed from http://json.org/json2.js

        if (rvalidchars.test(data
            .replace(rvalidescape, "@")
            .replace(rvalidtokens, "]")
            .replace(rvalidbraces, ""))) {

          // Try to use the native JSON parser

          if (extendedJSON || (nativeJSON && convertDates !== true)) {

            return window.JSON.parse(data, convertDates === true ? jsonDateConverter : undefined);

          } else {

            data = convertDates === true ?
              data.replace(replaceISO, "new Date(parseInt('$1',10),parseInt('$2',10)-1,parseInt('$3',10),parseInt('$4',10),parseInt('$5',10),parseInt('$6',10),(function(s){return parseInt(s,10)||0;})('$7'))")
                .replace(replaceNet, "new Date($1)") :
              data;

            return (new Function("return " + data))();

          }

        } else {

          $.error("Invalid JSON: " + data);

        }

      }
    });

  })(jQuery);
  //jqGridSortOrder
  $.extend($, {
    AppendGridSortParams: function (gridObj, url) {
      var sortName = $(gridObj).getGridParam('sortname');
      var sortOrder = $(gridObj).getGridParam('sortorder');
      if (url.indexOf("?") > 0) {
        url = url + "&GridSortName=";
      } else {
        url = url + "?GridSortName=";
      }
      url = url + sortName + "&GridSortOrder=" + sortOrder;
      return url;
    },
    AjaxResponseWithInfoAndError: function(data, caption, errorFunction) {
        if (data.Successfull) {
            if (data.Message != null && data.Message.length > 0) {
                $.infoDialog(data.Message, caption);
            }
            return true;
        }
        if (data.Errors.length > 0) {
            var errors = data.Errors;
            DisplayServerErrors(errors, caption, '', errorFunction);           
        }
        return false;
    },
    AjaxResponseWithInfoOnly: function (data, caption) {
        if (data.Successfull) {
            if (data.Message != null) {
                $.infoDialog(data.Message, caption);
            }
            return true;
        }        
        return false;
    }
  });

 // FIXES FOR IE - missing JS Implementations:
  $.arrayIndexOf = function(array, obj) {
  	for (var i = 0; i < array.length; i++) {
  		if (array[i] == obj) {
  			return i;
  		}
  	}
  	return -1;
  };

// Fixes for 1.7 to 1.9 jquery upgrade
  //this is used by mcDropDown
  $.curCSS = function (obj, prop, ignore) {
      return parseInt($(obj).css(prop)); // replaces parseInt($.curCSS($el[0], "marginLeft", true), 10) || 0
  };

function riskLevelRenderer(data) {
	if (data["RiskLevel"]) {
		var rating = "";
		if (data["RiskRating"])
			rating = " (" + data['RiskRating'] + ")";
		return "<div><div style='margin-left:10px;' title='" + data.RiskLevel + rating + "'><i class='" + data.RiskIconClass + "' style='color:#" + data.RiskColour + "'></i></div>";
	}
	return "<div></div>";
}